var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1826 2.72297C11.6439 2.29547 12.3563 2.29547 12.8139 2.72297L16.2001 5.86172V5.40047C16.2001 4.73672 16.7363 4.20047 17.4001 4.20047H18.6001C19.2638 4.20047 19.8001 4.73672 19.8001 5.40047V9.20672L21.2176 10.523C21.5776 10.8605 21.6976 11.3817 21.5176 11.8392C21.3376 12.2967 20.8951 12.6005 20.4001 12.6005H19.8001V19.2005C19.8001 20.5242 18.7239 21.6005 17.4001 21.6005H6.6001C5.27635 21.6005 4.2001 20.5242 4.2001 19.2005V12.6005H3.6001C3.1051 12.6005 2.6626 12.2967 2.4826 11.8392C2.3026 11.3817 2.4226 10.8567 2.7826 10.523L11.1826 2.72297ZM11.4001 14.4005C10.4064 14.4005 9.6001 15.2067 9.6001 16.2005V19.8005H14.4001V16.2005C14.4001 15.2067 13.5939 14.4005 12.6001 14.4005H11.4001Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ae58167e95af0c078064f8f26451a8c4.svg";
export { ForwardRef as ReactComponent };